class Collectivity {
  constructor(params) {
    this.phoneNumber = params.phoneNumber;
    this.isDefaultHours = params.isDefaultHours;
    this.openingHoursOfWeek = params.openingHoursOfWeek;
    this.nextAvailableDate = params.nextAvailableDate;
    return this;
  }
}
export { Collectivity as default };
